<template>
    <div>{{ formattedTimeLeft }}</div>
</template>

<script>
// packages
import {
    onMounted,
    reactive,
    computed,
    watch
} from '@vue/composition-api';

export default {
    props: {
        timeLimit: {
            type: Number,
            default: 5
        },
        stop: {
            type: Boolean,
            default: false
        },
        isNecessaryToEmitSeconds: {
            type: Boolean,
            default: false
        }
    },
    setup ( props, { emit }) {
        // definição da reactividade
        const state = reactive({
            time: props.timeLimit,
            timePassed: 0,
            timerInterval: null
        });

        /**
         * [função]
         * Comportamento aquando é necessário
         * parar o contador.
         *
         * @since 1.0.0
         * @category Função
         * @autor Tiago Martinho
         *
        */
        const onTimesUp = () => {
            clearInterval( state.timerInterval );

            if ( props.isNecessaryToEmitSeconds )
                emit( 'get-seconds', -1 );
        };

        /**
         * [função]
         * Iniciação do contador.
         *
         * @since 1.0.0
         * @category Função
         * @autor Tiago Martinho
         *
        */
        const startTimer = () => {
            state.timePassed++;
            // eslint-disable-next-line
            state.timerInterval = setInterval( () => ( state.timePassed++ ), 1000 );
        };

        /**
         * [computed]
         * Obtenção do tempo em falta.
         *
         * @since 1.0.0
         * @category computed
         * @autor Tiago Martinho
         *
        */
        const timeLeft = computed( () => {
            const time = Math.abs( props.timeLimit - state.timePassed );

            if ( props.isNecessaryToEmitSeconds && time !== state.time )
                emit( 'get-seconds', time );

            return time;
        });

        /**
         * [computed]
         * Formatação do tempo.
         *
         * @since 1.0.0
         * @category computed
         * @autor Tiago Martinho
         *
        */
        const formattedTimeLeft = computed( () => {
            const minutes = `${Math.floor( timeLeft.value / 60 )}`.padStart( 2, '0' );
            const seconds = `${Math.floor( timeLeft.value % 60 )}`.padStart( 2, '0' );

            return `${minutes}:${seconds}`;
        });

        /**
         * [listener]
         * Listener do tempo em falta,
         * de forma a saber quando é necessário
         * parar o contador.
         *
         * @since 1.0.0
         * @category listener
         * @autor Tiago Martinho
         *
        */
        watch( () => timeLeft.value,
            newTime => {
                state.time = newTime;

                if ( newTime === 0 ) {
                    onTimesUp();
                    emit( 'finished' );
                }
            });

        /**
         * [listener]
         * Listener de quando é necessário
         * parar o contador. Esta acção virá
         * do elemento pai.
         *
         * @since 1.0.0
         * @category listener
         * @autor Tiago Martinho
         *
        */
        watch( () => props.stop,
            stop => {
                stop ? onTimesUp() : startTimer();
            });

        // iniciação do timer.
        onMounted( startTimer );

        return { formattedTimeLeft };
    }
};
</script>

<style scoped lang="scss">
    .base-timer {
        position: relative;
        width: 300px;
        height: 300px;
        &__svg {
            transform: scaleX(-1);
        }

        &__circle {
            fill: none;
            stroke: none;
        }

        &__path-elapsed {
            stroke-width: 7px;
            stroke: grey;
        }

        &__path-remaining {
            stroke-width: 7px;
            stroke-linecap: round;
            transform: rotate(90deg);
            transform-origin: center;
            transition: 1s linear all;
            fill-rule: nonzero;
            stroke: currentColor;

            &.green {
            color: rgb(65, 184, 131);
            }

            &.orange {
            color: orange;
            }

            &.red {
            color: red;
            }
        }

        &__label {
            position: absolute;
            width: 300px;
            height: 300px;
            top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 48px;
        }
    }
</style>